import { reducedStream, reducer, streamReducer } from '@ardoq/rxbeach';
import { Observable } from 'rxjs';
import { setStateProperty } from '@ardoq/common-helpers';
import { metamodelViewOperations } from './metamodelViewOperations';
import { fields$ } from 'streams/fields/fields$';
import { loadMetaModel$ } from 'architectureModel/loadMetaModel';
import { persistentWorkspaces$ as workspaces$ } from 'streams/workspaces/workspaces$';
import { locale$ } from 'streams/locale$';
import { toggleExpandableSection, toggleIsSelectedGraphNode } from './actions';
import { MetamodelViewState } from './types';

export const createMetamodelView$ = (
  namespace: string
): Observable<MetamodelViewState> =>
  reducedStream(
    `metamodelView$:${namespace}`,
    metamodelViewOperations.getInitialState(),
    [
      streamReducer(locale$, setStateProperty('locale')),
      streamReducer(fields$, metamodelViewOperations.createFieldMap),
      streamReducer(workspaces$, metamodelViewOperations.createWorkspaceMap),
      streamReducer(
        loadMetaModel$,
        metamodelViewOperations.typeNameToWorkspaceAndFieldMaps
      ),
      reducer(
        toggleIsSelectedGraphNode,
        metamodelViewOperations.toggleIsSelectedGraphNode
      ),
      reducer(
        toggleExpandableSection,
        metamodelViewOperations.toggleExpandableSection
      ),
    ],
    { namespace }
  );
